"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexColumn = exports.FlexRow = exports.Flex = exports.centerContents = void 0;
var ViewWithStyle_1 = require("./ViewWithStyle");
/**
 * shared default style between flex row and column
 * includes flexDirection, but this can be overwritten
 */
exports.centerContents = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    flexDirection: "row",
    flexWrap: "nowrap"
};
/**
 * don't want to pass through all props, just FlexProps
 * picks out top-level FlexProps and applies centerContents as the default such that all are defined
 */
var extractFlexProps = function (props) {
    var combined = __assign(__assign({}, exports.centerContents), props);
    var flexDirection = combined.flexDirection, flexWrap = combined.flexWrap, alignContent = combined.alignContent, alignItems = combined.alignItems, justifyContent = combined.justifyContent, display = combined.display;
    return { flexDirection: flexDirection, flexWrap: flexWrap, alignContent: alignContent, alignItems: alignItems, justifyContent: justifyContent, display: display };
};
/**
 * basic Flex component uses centerContents as the default style with flexDirection = row, but this can be overwritten
 * with prop flexDirection
 */
exports.Flex = ViewWithStyle_1.ViewWithStyle(extractFlexProps);
/**
 * automatically applies flexDirection to Flex component
 */
exports.FlexRow = function (props) { return exports.Flex(__assign(__assign({}, props), { flexDirection: "row" })); };
exports.FlexColumn = function (props) { return exports.Flex(__assign(__assign({}, props), { flexDirection: "column" })); };
//# sourceMappingURL=Flex.js.map